module.exports = __webpack_public_path__ + "img/tracking-empty-state.692b8d6e.png";